import React from "react";
import { InfoIcon } from "../../icons";
import HintTooltip from "./HintTooltip";
import useStyles from "./HintTooltip.style";

// The icon sits inside a checkbox/switch label, so its click must not toggle that control
const preventToggle = (event: any) => {
  event.preventDefault();
};

// Info icon with a hint, like coolremote-commercial's hints (its InfoIcon inside its LightTooltip).
// Clicking the icon must not toggle a checkbox or switch it sits next to.
const InfoHint = ({ title, placement }: any) => {
  const classes: any = useStyles();
  return (
    <HintTooltip title={title} placement={placement}>
      <span className={classes.trigger} onClick={preventToggle}>
        <InfoIcon className={classes.icon} />
      </span>
    </HintTooltip>
  );
};

export default InfoHint;
